export default __webpack_public_path__ + "static/media/mpetonmeparalia.61f38f99.webp";